<template>
    <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label">
            {{amenity.name}}
        </label>
        <div class="md-layout-item md-size-50">
            <md-field>
                <md-input :type="amenity.details.type" v-model="amenity.details.model" :placeholder="amenity.details.placeholder" />
                <span class="md-helper-text">{{amenity.details.help}}</span>
            </md-field>
        </div>
    </div>
</template>
<script>
    export default {
        name: "AmenityText",
        props: {
            amenity: null
        }
    };
</script>
<style>
   
</style>
